import { render, staticRenderFns } from "./Daiyuyue.vue?vue&type=template&id=0503a391&scoped=true"
import script from "./Daiyuyue.vue?vue&type=script&lang=js"
export * from "./Daiyuyue.vue?vue&type=script&lang=js"
import style0 from "./Daiyuyue.vue?vue&type=style&index=0&id=0503a391&prod&lang=css"
import style1 from "./Daiyuyue.vue?vue&type=style&index=1&id=0503a391&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0503a391",
  null
  
)

export default component.exports